import React, { useRef, useState, useEffect } from 'react';
import axios from 'axios';
import "./BusinessName.css";
import flashMessage from '../HelperFunctions';


function BusinessName({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `Acme Co`;

  const typingTimer = useRef(null);
  const nameInputRef = useRef(null);

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  useEffect(() => {

    if (organization && organization.business_name) {
      nameInputRef.current.value = organization.business_name;
    }

  }, [organization?.business_name]);

  return (

    <div className="customize-ai-section">
      <span>
        Business Name
      </span>
      <input
        data-say-id="knowledge-base-business-name"
        ref={nameInputRef}
        className="business-name-text"
        placeholder={placeholderText}
        defaultValue={organization.business_name}
        onChange={handleInputChange}
      />

    </div>


  );
}

export default BusinessName;
